import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  privacyPolicyContent: SafeHtml = '';
  isLoading = true;
  errorMessage = '';

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loadPrivacyPolicy();
  }

  loadPrivacyPolicy(): void {
    this.http.get('/assets/privacy-policy.html', { responseType: 'text' })
      .subscribe({
        next: (html: string) => {
          this.privacyPolicyContent = this.sanitizer.bypassSecurityTrustHtml(html);
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading privacy policy:', error);
          this.errorMessage = 'Failed to load privacy policy. Please try again later.';
          this.isLoading = false;
        }
      });
  }

  goBack(): void {
    window.history.back();
  }
}

